// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CalendarEventType } from './calendar-event-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CalendarEvent extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  contactPerson?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  description?: string;
  endTime?: Date;
  eventDate!: Date;
  location?: string;
  name?: string;
  officeInformation?: string;
  price?: number;
  privateEvent!: boolean;
  startTime?: Date;
  typeId!: number;
  type!: CalendarEventType;
}

